import { useMemo } from 'react';

import { mapValues } from 'lodash';
import { useTranslation } from 'react-i18next';

export function getTranslationKeysHook<T>(keys: Record<string, string>) {
	return () => {
		const { t } = useTranslation();

		return useMemo(() => mapValues(keys, t), [t]) as unknown as T;
	};
}
